import { InvoiceCurrency } from '@core/api/entities/invoice/invoiceCurrency'

import { InvoiceCurrencyResponseDTO } from '../../dtos/response/invoice/invoiceCurrency'

export class InvoiceCurrencyMapper {
	static toEntity(dto: InvoiceCurrencyResponseDTO): InvoiceCurrency {
		return InvoiceCurrency.create({
			iso: dto.iso,
			relation: dto.relation,
		})
	}

	static toEntities(dtos: InvoiceCurrencyResponseDTO[]): InvoiceCurrency[] {
		return dtos.map(this.toEntity)
	}
}
